import React, { useState, useEffect, Suspense } from 'react';

import Loader from 'components/common/ui/Loader';

const Registry = React.lazy(() => import('./Registry/RegistryV2'));
const WebsitePreview = React.lazy(() => import('../../WebsitePreview'));
const RegistryOnboardContainer = React.lazy(() =>
  import('./RegistryOnboardContainer/RegistryOnboardContainer')
);
const StartRegistry = React.lazy(() => import('./StartRegistry'));

const RegistryContainer = ({ getRegistryEntities, hasRegistry, inWebToRegExperiment }) => {
  const [registriesReceived, setRegistriesReceived] = useState(false);

  useEffect(() => {
    getRegistryEntities(() => setRegistriesReceived(true));
  }, []);

  const renderContainerWithPreview = component => {
    return (
      <Suspense fallback={<Loader />}>
        <div className="container-fluid">
          <div className="row">
            <div className="column col-xs-12 col-md-5">{component}</div>
            <div className="column col-md-7 hidden-sm hidden-xs">
              <WebsitePreview
                pageType="REGISTRY"
                showGraphic={!hasRegistry && inWebToRegExperiment}
              />
            </div>
          </div>
        </div>
      </Suspense>
    );
  };

  if (!registriesReceived) {
    return <Loader />;
  }

  if (registriesReceived && !hasRegistry && inWebToRegExperiment) {
    return renderContainerWithPreview(<StartRegistry />);
  }

  if (registriesReceived && !hasRegistry && !inWebToRegExperiment) {
    return (
      <Suspense fallback={<Loader />}>
        <RegistryOnboardContainer />
      </Suspense>
    );
  }

  return renderContainerWithPreview(
    <Registry useDragHandle lockAxis="y" inWebToRegExperiment={inWebToRegExperiment} />
  );
};

export default RegistryContainer;
